import { type IApiGeoGeocodedForSearchResponse } from '@/repositories/generated/shared/monolith-cian-realty/api/geo/geocoded-for-search';

import { type TFetchGeocodedForSearchResponse } from '../types/geocodedForSearch';

export function prepareGeocodedForSearch(data: IApiGeoGeocodedForSearchResponse): TFetchGeocodedForSearchResponse {
  return {
    ...data,
    geo: data.geo || { lat: 0, lng: 0 },
    details: data.details || [],
  };
}
